import {ensureErrorType, ErrorBundle, errorToErrorBundle, translation} from "@2d-front-monorepo/core";
import {JSX, useEffect, useRef, useState} from "react";
import ErrorDetail from "../Errors/ErrorDetail";
import Dialog from "./Dialog";

interface ErrorDialogData {
	error: ErrorBundle
	onCloseHandler?: () => void;
}

export function showErrorDialog(error: unknown, onCloseHandler?: () => void): void;
export function showErrorDialog(error: Error, onCloseHandler?: () => void): void;
export function showErrorDialog(error: ErrorBundle, onCloseHandler?: () => void): void;
export function showErrorDialog(error: ErrorBundle | Error | unknown, onCloseHandler?: () => void): void {
	if (error == null) {
		return;
	}

	let errorBundle: ErrorBundle;
	if (error instanceof Error) {
		errorBundle = errorToErrorBundle(error);

	} else if (typeof error === "object" && "title" in error && "errors" in error && Array.isArray((error as any).errors)) {
		errorBundle = error as ErrorBundle;

	} else {
		errorBundle = errorToErrorBundle(ensureErrorType(error));
	}

	window.dispatchEvent(new window.CustomEvent("show-dialog", {
		detail: {error: errorBundle, onCloseHandler}
	}));
}

export default function ErrorDialog(): JSX.Element | null {
	const [data, setData] = useState<ErrorDialogData | null>(null);
	const dialogRef = useRef<HTMLDialogElement>(null);

	useEffect(() => {
		const handleShow = (e: Event) => setData((e as CustomEvent<ErrorDialogData>).detail);
		const handleHide = () => setData(null);

		window.addEventListener("show-dialog", handleShow);
		window.addEventListener("hide-dialog", handleHide);

		return () => {
			window.removeEventListener("show-dialog", handleShow);
			window.removeEventListener("hide-dialog", handleHide)
		}
	}, []);

	useEffect(() => {
		if (data && dialogRef.current) {
			const handleClose = () => {
				setData(null);
				data.onCloseHandler?.();
			};

			const dialog = dialogRef.current;
			dialog.addEventListener("close", handleClose);
			return () => dialog.removeEventListener("close", handleClose);
		}

		return () => {
		};
	}, [data]);

	return data?.error ?
		<Dialog title={translation(data.error.title)} ref={dialogRef}>
			<ErrorDetail error={data.error}/>
		</Dialog>
		: null;
};
